var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"LanguagesList"},_vm._l((_vm.list),function(item,index){return _c('LanguagesItem',{key:index,attrs:{"item":item},nativeOn:{"click":function($event){return _vm.selectItem(item)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }